export default function () {
  const equalHeight = () => {
	  let tabImg =  document.querySelectorAll(".tab__image img");
	 
	  if (!tabImg) {
		return;
	  }
	  for (let i = 0; i < tabImg.length; i++) {
		const element = tabImg[i];
		let tabH = element.offsetHeight;
		let tabI = element.closest(".tab__image").style.height = tabH+'px';
	  }
	   
  };

  let tabToggler = document.querySelectorAll("[data-toggle-tab]");
  if (!tabToggler) {
    return;
  }

  equalHeight();

  let tabs = document.querySelectorAll("[data-tab]");
  for (let i = 0; i < tabToggler.length; i++) {
    const element = tabToggler[i];
    element.addEventListener("click", function () {
      handleTabClick(this);
    });
  }

  const handleTabClick = (e) => {
    let tabIndex = e.getAttribute("data-toggle-tab");
	let tab = document.querySelector(`[data-tab="${tabIndex}"]`);
	let tabsContainer = document.querySelector('.tabs__items');
	
	let tabHeight = tab.offsetHeight;

    for (let i = 0; i < tabToggler.length; i++) {
      const element = tabToggler[i];
      element.classList.remove("active");
    }

    for (let i = 0; i < tabs.length; i++) {
      const element = tabs[i];
      element.classList.remove("active");
	}
	
	tabsContainer.style.minHeight = tabHeight+'px';

    tab.classList.add("active");
    e.classList.add("active");
  };
}
